// 261010 Epic 2 / P4b-2 — ngăn so sánh (theo mẫu `shot-02`): bấm ảnh một hướng ⇒ ảnh chuẩn bên trái, ảnh hướng bên phải, tab theo các hướng.
// KHÁC mẫu (Phase doc "Khác mẫu đã duyệt"): KHÔNG tô "ô gần nhất" của sheet — prompt P4a vẽ theo `directionText`, không theo ô sheet; chỉ ghi "Ảnh hướng vẽ theo ảnh chuẩn này".
import React from 'react';
import { Drawer } from 'antd';
import type { LocationView } from '../../types/filmLocationAssets';
import { viewChip, viewNote, type LocAction, type LocActionKey, type CanonicalLite, canonicalChip } from './locationAssetsPolicy';

interface Props {
  open: boolean;
  onClose: () => void;
  locationName: string;
  canonical: CanonicalLite;
  views: LocationView[];
  activeId: string | null;
  onSelect: (viewId: string) => void;
  actionsOf: (v: LocationView) => LocAction[];
  onAction: (key: LocActionKey, v: LocationView) => void;
  /** Đang có một thao tác ghi chạy ở thẻ ⇒ khoá nút. */
  busy: boolean;
}

const LocationViewCompareDrawer: React.FC<Props> = ({ open, onClose, locationName, canonical, views, activeId, onSelect, actionsOf, onAction, busy }) => {
  const cur = views.find((v) => v.id === activeId) ?? views[0] ?? null;
  const cc = canonicalChip(canonical);
  return (
    <Drawer title={`Hướng · ${locationName}`} open={open} onClose={onClose} width="min(1040px, 96vw)" destroyOnClose>
      <div className="wf" style={{ background: 'transparent', padding: 0, minHeight: 0 }}>
        {!cur ? <p className="muted">Chưa có hướng nào.</p> : (<>
          <div className="wf-cmp-tabs" role="tablist" aria-label="Các hướng của bối cảnh">
            {views.map((v) => (
              <button key={v.id} type="button" role="tab" aria-selected={v.id === cur.id} className={`wf-cmp-tab${v.id === cur.id ? ' on' : ''}`} onClick={() => onSelect(v.id)}>{v.label}</button>))}
          </div>
          <div className="wf-cmp">
            <section aria-label="Ảnh chuẩn">
              <div className="wf-cmp-h"><b>Ảnh chuẩn</b><span className={`wf-chip ${cc.tone}`}>{cc.label}</span></div>
              {canonical.url ? <img className="wf-img" src={canonical.url} alt={`Ảnh chuẩn ${locationName}`} /> : <p className="muted">Chưa có ảnh chuẩn.</p>}
              <p className="wf-note" style={{ marginTop: 8 }}>Ảnh hướng vẽ theo ảnh chuẩn này.</p>
              <dl className="wf-cmp-kv">
                <dt>Mã hướng</dt><dd className="mono">{cur.directionKey}</dd>
                <dt>Khung ảnh</dt><dd>dọc 9:16</dd>
              </dl>
              <h3>Mô tả hướng</h3>
              <p style={{ margin: 0, overflowWrap: 'anywhere' }}>{cur.directionText}</p>
            </section>
            <section aria-label={`Ảnh hướng ${cur.label}`}>
              <div className="wf-cmp-h"><b>Ảnh hướng “{cur.label}”</b><span className={`wf-chip ${viewChip(cur).tone}`}>{viewChip(cur).label}</span></div>
              {viewNote(cur) ? <p className={`wf-view-note${cur.status === 'ERROR' ? ' bad' : ''}`}>{viewNote(cur)}</p> : null}
              {cur.imageUrl
                ? <img className={`wf-img wf-img-v${cur.status === 'STALE' ? ' old' : ''}`} src={cur.imageUrl} alt={`Ảnh hướng ${cur.label}`} />
                : <div className="wf-vthumb empty">{cur.status === 'GENERATING' ? 'Đang tạo ảnh…' : 'Chưa có ảnh'}</div>}
              <div className="wf-cmp-act">
                {actionsOf(cur).map((a) => (
                  <button key={a.key} type="button" className={`wf-btn${a.key === 'VIEW_GENERATE' && a.enabled ? ' primary' : ''}`} disabled={!a.enabled || busy} title={a.reason} onClick={() => onAction(a.key, cur)}>{a.label}</button>))}
                <button type="button" className="wf-btn ghost" onClick={onClose}>Đóng</button>
              </div>
              {actionsOf(cur).filter((a) => !a.enabled && a.reason).map((a) => <p key={a.key} className="faint" style={{ fontSize: 12, margin: '4px 0 0' }}>{a.label}: {a.reason}</p>)}
            </section>
          </div>
        </>)}
      </div>
    </Drawer>
  );
};

export default LocationViewCompareDrawer;
